export { default } from "./PaymentIcon";
